<template>
    <div>
        <button
            type="button"
            class="btn btn-pdv btn-pdv-blue mr-1"
            href="javascript: void(0);"
            :disabled="loading"
            @click="handleOk"
        >
            <b-spinner v-if="loading" small class="mr-1" />
            <i v-else class="fe-download mr-1"></i>
            {{ title === '' ? getI18n('COMMON', 'export') : title }}
        </button>
        <no-data-export-modal ref="noDataExportModal" />
        <export-modal ref="exportModalRef"
            :type="'mix'"
            :create-parameters="createParameters"
            :available-types="['mix', 'mix_has_product']"
        />
    </div>
</template>

<script>
    import ExportJobService from '@src/services/ExportJobService'
    import swalFeedback from '@src/mixins/swalFeedback'
    import NoDataExportModal from '@/src/components/NoDataExportModal.vue'
    import exportModal from '@views/exportJob/exportJobModal'

    export default {
        components: {
            NoDataExportModal,
            exportModal,
        },
        mixins: [swalFeedback],
        props: {
            title: {
                type: String,
                default: '',
            },
            createParameters: {
                type: Function,
                required: true,
            },
            vuetableRef: {
                type: Object,
                required: false,
                default: null
            },
        },
        data() {
            return {
                loading: false,
                type: 'mix',
            }
        },
        computed: {
            i18nType() {
                return this.getI18n('EXPORT_JOBS', `TYPES.${this.type}`)
            }
        },
        methods: {
            async handleOk() {
                const data = this.vuetableRef?.vuetable?.$refs?.vuetable?.tableData || [];
                const hasDataLoaded = data.length > 0;

                if (!hasDataLoaded) {
                    this.$refs.noDataExportModal.showModal();
                    return;
                }

                if (!this.loading) {
                    this.$refs.exportModalRef.showModal(false, this.handleSubmit)
                }
            },
            async handleSubmit(submit) {
                if (!submit) return;

                this.loading = true;

                try {
                    let parameters = await this.createParameters();
                    parameters = {
                        ...parameters,
                        export_type: this.type,
                        language: 'pt_BR',
                    };

                    const createResponse = await ExportJobService.create(parameters)
                        .then((response) => response)
                        .catch((error) => error);

                    const statusCode = ExportJobService.exportStatus(createResponse);

                    if (statusCode.charAt(0) === '2') {
                        this.$router.push({ name: 'exportJobs', params: { newJobCreated: true } });
                    } else {
                        this.negativeFeedback(
                            this.getI18n('RESPONSES', 'create_not_possible'),
                            ExportJobService.exportErrorMessage(createResponse)
                        );
                    }
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>
